import { pxToRem } from '../../utils';
export default (function () { return ({
    width: undefined,
    height: undefined,
    avatarRadius: pxToRem(9999),
    avatarSize: pxToRem(32),
}); });
